import { FC, useCallback, MouseEvent } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import MuiTablePagination, {
  TablePaginationProps,
} from '@mui/material/TablePagination';

import { TablePagination_pageInfo$key } from '__generated__/TablePagination_pageInfo.graphql';
import { usePagination } from 'components/Pagination';

type Props = {
  pageInfo: TablePagination_pageInfo$key | null;
} & Omit<
  TablePaginationProps,
  'count' | 'rowsPerPage' | 'page' | 'onPageChange'
>;

const TablePagination: FC<Props> = ({ pageInfo, ...rest }) => {
  const { page, itemsPerPage, changePage } = usePagination();

  const handlePageChange = useCallback(
    (_: MouseEvent<HTMLButtonElement> | null, page: number) => {
      changePage(page);
    },
    [changePage]
  );

  const info = useFragment(
    graphql`
      fragment TablePagination_pageInfo on PageInfo {
        total
      }
    `,
    pageInfo
  );

  return (
    <MuiTablePagination
      component="div"
      {...rest}
      count={info?.total ?? 0}
      rowsPerPageOptions={[]}
      rowsPerPage={itemsPerPage}
      onPageChange={handlePageChange}
      page={page}
    />
  );
};

export default TablePagination;
